import { useEffect, useState } from "react";
import { fetchPayersByFinanceClass } from "../api/registrationService";

export function usePayersByFinanceClass(financialClass) {
  const [payers, setPayers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const normalizedClass = String(financialClass || "").trim();
    if (!normalizedClass) {
      setPayers([]);
      setLoading(false);
      return undefined;
    }

    let cancelled = false;
    setLoading(true);

    fetchPayersByFinanceClass(normalizedClass)
      .then((list) => {
        if (!cancelled) setPayers(list);
      })
      .catch(() => {
        if (!cancelled) setPayers([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, [financialClass]);

  return { payers, loading };
}
